import { Injectable, inject } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { HuntingEvent, NetworkConstants, EventInvitation, EventTransaction } from 'diwimamodelweb/lib';
import { deepCopy, removeUndefined } from 'diwimamodelweb/lib/utils/obejct-diff';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { UserService } from 'src/app/shared/user.service';
import { doc, Firestore, where, collectionData, collection, query, writeBatch } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class EventInviteSharedService {
  private Ifirestore = inject(Firestore);

  ngUnsubscribe: Subject<void> = new Subject<void>();
  sub: Map<string, Subscription> = new Map()
  
  selectedEvent$ = new BehaviorSubject(undefined)
  eventInvitations$ = new BehaviorSubject<EventInvitation[]>(undefined)
  personInvites$ = new BehaviorSubject<EventInvitation[]>(undefined)

  allInvitations$ = new BehaviorSubject<EventInvitation[]>(undefined)

  constructor(
    private firestore: AngularFirestore,
    private userService: UserService,
  ) {
      this.selectedEvent$
      // .pipe()
      .subscribe((event) => {
        if (!event) return 
        this.sub.set(event.identifier, this.observeInvitations(event))  
      })
  }

  async removeSubs(): Promise<void> {
    this.ngUnsubscribe.next()
    this.sub.forEach(value => value.unsubscribe())
    return Promise.resolve()
  }

  observeInvitations(selectedEvent: HuntingEvent) {
    this.eventInvitations$.next(undefined)
    const path = `${NetworkConstants.COLLECTION_EVENT_INV}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('eventId', '==', selectedEvent.identifier));

    // return this.firestore.collection(NetworkConstants.COLLECTION_EVENT_INV, ref => ref.where('eventId', "==", selectedEvent.identifier)).valueChanges()
    return collectionData(q)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (data: any[]) => {
        if (!data) return 
        // build classes ... 
        let listInvites = []
        data.forEach(element => {
          const invite = EventInvitation.builder.fromAny(element)
          if (!invite) return 
          listInvites.push(
            invite
          )
        });
        this.eventInvitations$.next(listInvites)
      },
      error: (error) => {
        console.error(error);
      }
    })
  }

  observeInvitationsOfPerson(personId: string) {
    const path = `${NetworkConstants.COLLECTION_EVENT_INV}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('personId', '==', personId));

    // return this.firestore.collection( NetworkConstants.COLLECTION_EVENT_INV, ref => ref.where('personId', "==", personId)).valueChanges()
    return collectionData(q)
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe({
      next: (data) => {
        if (!data) return
        // build classes ...
          let listInvites = []
          data.forEach(element => {
            const invite = EventInvitation.builder.fromAny(element)
            if (!invite) return 
            listInvites.push(
              invite
            )
          });
          this.personInvites$.next(listInvites)
      },
      error: (error) => { console.log(error) }
    })
  }

  observeAllInvitations(contextId: string) {
    const path = `${NetworkConstants.COLLECTION_EVENT_INV}`
    const collRef = collection(this.Ifirestore, path);
    const q = query(collRef, where('contextId', '==', contextId));

    // return this.firestore.collection(NetworkConstants.COLLECTION_EVENT_INV, ref => ref.where('contextId', "==", contextId)).valueChanges()
    return collectionData(q)
      .pipe(
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe({
        next: (data: any[]) => {
          if (!data) return 
          // build classes ... 
          let listInvites = []
          data.forEach(element => {
            const invite = EventInvitation.builder.fromAny(element)
            if (!invite) return 
            listInvites.push( invite )
          });
          this.allInvitations$.next(listInvites)
        },
        error: (error) => { console.log(error) }
      })
  }

  async saveNewInvitations(invitations: EventInvitation[]): Promise<void> {
    if (invitations.length == 0 || invitations.length >= 500) return 
    const user = await this.userService.user$.pipe(take(1)).toPromise()
    const now = new Date()
    // let batch = this.firestore.firestore.batch()
    const batch = writeBatch(this.Ifirestore);

    for (let invite of invitations) {
      invite.identifier = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_EVENT_INV))?.id
      // invite.identifier = this.firestore.collection(NetworkConstants.COLLECTION_EVENT_INV).doc().ref.id
      invite.creationDate = now
      invite.updateTimestamp = now
      const inviteRef = doc(this.Ifirestore, `${NetworkConstants.COLLECTION_EVENT_INV}/${invite.identifier}`);
      batch.set(
        inviteRef,
        // this.firestore.firestore.collection(NetworkConstants.COLLECTION_EVENT_INV).doc(invite.identifier), 
        {...removeUndefined(invite)}, {merge: true}
      )
      const transaction = EventTransaction.builder.createFromNewInvitation(invite, {userId: user?.identifier, userDisplayName: user?.displayName, deviceName: 'RC-Web'})
      transaction.identifier = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_EVENT_TRANSACTION))?.id
      // transaction.identifier = this.firestore.collection(NetworkConstants.COLLECTION_EVENT_TRANSACTION).doc().ref.id
      const dbData = deepCopy(transaction, transaction.replacerFn)
      dbData['creationDate'] = now
      const transactionRef = doc(this.Ifirestore, `${NetworkConstants.COLLECTION_EVENT_TRANSACTION}/${invite.identifier}`);
      batch.set(
        // this.firestore.firestore.collection(NetworkConstants.COLLECTION_EVENT_TRANSACTION).doc(invite.identifier),
        transactionRef,
        {...removeUndefined(dbData)}, {merge: true}
      )
    }
    try {
      await batch.commit()
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateSingleInvitation(oldInvitation: EventInvitation, newInvitation: EventInvitation): Promise<void> {
    // let batch = this.firestore.firestore.batch()
    const batch = writeBatch(this.Ifirestore);
    try {
      const now = new Date()
      const user = await this.userService.user$.pipe(take(1)).toPromise()
      const transaction = EventTransaction.builder.createUpdate(
        oldInvitation, newInvitation,
        {userId: user?.identifier, userDisplayName: user?.displayName, deviceName: 'RC-Web'}  
      )
      const update = Object.assign({}, transaction.updateOperations, {updateTimestamp: now})
      const invitationRef = doc(this.Ifirestore, `${NetworkConstants.COLLECTION_EVENT_INV}/${newInvitation.identifier}`);
      // save ... 
      batch.set(
        // this.firestore.firestore.collection(NetworkConstants.COLLECTION_EVENT_INV).doc(newInvitation.identifier),
        invitationRef, update, {merge: true}
      )
      // save transaction 
      const invTransactions = deepCopy(transaction, transaction.replacerFn)
      const id = doc(collection(this.Ifirestore, NetworkConstants.COLLECTION_EVENT_TRANSACTION))?.id

      // const id = this.firestore.collection(NetworkConstants.COLLECTION_EVENT_TRANSACTION).doc().ref.id
      invTransactions['identifier'] = id
      invTransactions['creationDate'] = now
      const toSave = removeUndefined(invTransactions)
      const event_transactionRef = doc(this.Ifirestore, `${NetworkConstants.COLLECTION_EVENT_TRANSACTION}/${id}`);
      batch.set(
        // this.firestore.firestore.collection(NetworkConstants.COLLECTION_EVENT_TRANSACTION).doc(id),
        event_transactionRef, toSave
      )
      await batch.commit()
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }
}
